const shipping = {
  mondialRelay: {
    enabled: true,
    brandCode: process.env.REACT_APP_MONDIAL_RELAY_BRAND || '',
    // Mode simulation pour développement (compte BDTEST ne retourne pas de points relais)
    useMockData: process.env.REACT_APP_MONDIAL_RELAY_USE_MOCK === 'true' || !process.env.REACT_APP_MONDIAL_RELAY_BRAND,
    colLivMod: '24R',
    country: 'FR',
    nbResults: 7,
    searchDelay: '',
    searchFar: '75',
    responsive: true,
    showResultsOnMap: true,
    enableGeolocalisedSearch: true,
    enableGmap: false,
    mapScrollWheel: true,
    widgetLanguage: process.env.REACT_APP_MONDIAL_RELAY_WIDGET_LANG || 'fr',
    jqueryUrl: process.env.REACT_APP_MONDIAL_RELAY_JQUERY_URL || '',
    methodIds: ['relay'],
    theme: 'mondialrelay',
  },
};

export default shipping;

